import tagColors from './cardTypeTagColors.json';
import type { TCardTypeTagColor } from 'types/cardTypeMessage';

type TCardTypeTagColorDefinition = {
  id: TCardTypeTagColor;
  label: string;
  backgroundColor: string;
  textColor: string;
};

/**
 * cardTypeTagColors.json は生成物。正本は
 * line-ban-backend/src/common/card-type/card-type-tag-colors.json で、
 * scripts/sync-card-type-tag-colors.mjs がここへコピーする（CI で同期を検証）。
 *
 * 色を追加する手順:
 * 1. バックエンドの JSON に追加し、`node scripts/sync-card-type-tag-colors.mjs` を実行する
 * 2. types/cardTypeMessage.ts の TCardTypeTagColor にキーを追加する
 *    （JSON の id は string に広がるため、ユニオンと下の as キャストで補っている）
 * 3. 色数を固定している両パッケージの spec を更新する
 */
export const CARD_TYPE_TAG_COLORS: TCardTypeTagColorDefinition[] =
  tagColors.map((color) => ({
    ...color,
    id: color.id as TCardTypeTagColor,
  }));

/** 未知・未指定の保存色は LINE 側と同じくグレーで描画する */
const FALLBACK_TAG_COLOR_ID: TCardTypeTagColor = 'gray';
const fallbackTagColor = CARD_TYPE_TAG_COLORS.find(
  (option) => option.id === FALLBACK_TAG_COLOR_ID,
)!;

export function getCardTypeTagColor(
  color: string | undefined,
): TCardTypeTagColorDefinition {
  return (
    CARD_TYPE_TAG_COLORS.find((option) => option.id === color)
    ?? fallbackTagColor
  );
}
